<template>
  <div class="cv-auxiliary-container">

    <!-- header -->
    <div class="auxiliary-header">

      <!-- tab -->
      <div class="auxiliary-option">
        <!-- 展开收起 -->
        <div class="icon-container" @click="changeBlockState">
          <i class="iconfont iconxiala" :class="blockState && auxiliaryPackup ? 'block-show' : 'block-hide'" />
        </div>
        <!-- title -->
        <!-- <h1>{{auxiliaryOption}}</h1> -->       
        <template v-for="(item, index) in auxiliaryOption">
          <div :key="index" class="option-item" v-if="item.show"
               :class="{ 'option-item-active': currentId === item.id && auxiliaryPackup}" @click="changeOption(item)">
            {{ item.name }}
          </div>
        </template>
      </div>

      <!-- 插入 slot -->
      <slot name="operation"></slot>

    </div>
    <!-- content 智能写简历 -->
    <div class="writing-content" v-show="currentId === 0 && auxiliaryPackup">

      <!-- 智能写简历 搜索 -->
      <div class="writing-search">

        <img src="https://files.wondercv.com/pc/jobscan/robot-gif.png" alt="">

        <div class="writing-search-box">

          <div class="writing-search-input-box">

            <div class="writing-search-tag" v-for="(item, index) in searchTagList" :key="`searchTag&${index}`">
              <span>{{ item }}</span>
              <i class="iconfont iconcha" @click="searchTagDeleteFunc(item)"></i>
            </div>

            <input class="writing-search-input" ref="searchInput" :style="{'width': searchTagList.length ? '120px' : '100%'}" v-show="maxTagLength" v-model="writingSearchWord" type="text" :placeholder="searchTagList.length ? '' : '请选择或输入该段经历中的动词/关键词，例：完成项目'" @keyup.enter="keyboardSearchFunc()" @keydown.delete="keyboardDelSearchFunc()" @input="checkInputFunc">

          </div>


          <div class="writing-search-btn" @click="keyboardSearchFunc()">
            <i class="iconfont iconsousuo1"></i>
          </div>
        </div>

        <div class="writing-search-random-btn" @click="randomSearchFunc()">
          <i class="iconfont iconhuanyihuan1"></i>
          <div class="search-random-tips" v-if="!randomTipsVisible">推荐一个</div>
          <div class="search-random-tips hover">推荐一个</div>
        </div>
      </div>

      <!-- 智能写简历 选择动名词 -->
      <div class="writing-word" :class="slideVisible && 'slide-down'">

        <!-- slide 收起状态 -->
        <template v-if="slideVisible">
          <div class="writing-word-slide-down-box">
            <h6 class="writing-word-slide-down-title">关键词推荐</h6>
            <div class="writing-word-slide-down-btn" @click="toggleSlideVisibleFunc()">
              <i class="iconfont iconzhankai"></i>
              <span>展开关键词</span>
            </div>
          </div>
        </template>
        
        <!-- slide 展开状态 -->
        <template v-else>
          <!-- 动名词  -->
          <div class="writing-word-top">

            <!-- 动词 -->
            <div class="writing-word-top-item verb">
              <h6 class="writing-word-top-item-header">高频动词推荐</h6>
              <div class="writing-word-top-item-tags" :class="moreVerbVisible && 'active'">
                <span class="writing-word-top-item-tag" :class="{'active': checkActiveWordTagFunc(item.cn)}" v-for="(item, index) in verbList" :key="`verbListItem&${index}`" @click="toggleWordTagFunc(item.cn)">{{ item.cn }}</span>
              </div>
              <div class="writing-word-top-item-more-btn" @click="showMoreVerbFunc()" v-show="!moreVerbVisible">查看更多动词<span>＞＞</span></div>
            </div>

            <div class="writing-word-top-line"></div>

            <!-- 名词 -->
            <div class="writing-word-top-item noun">
              <h6 class="writing-word-top-item-header" v-if="currentInfo.data.title ">关键词推荐</h6>
              <h6 class="writing-word-top-item-header" v-else>请填写<span style="color:#4183ff;">「职位名称」</span>获取精准推荐</h6>
              
              <div class="writing-word-top-item-tags">
                <span class="writing-word-top-item-tag" :class="{'active': checkActiveWordTagFunc(item)}" v-for="(item, index)  in nounList" :key="`nounListItem&${index}`" @click="toggleWordTagFunc(item)">{{ item }}</span>
              </div>
            </div>
    
          </div>

          <!-- 更多动词 -->
          <div class="writing-word-top-item more-verb" v-if="moreVerbVisible">
            <h6 class="writing-word-top-item-header">常用动词推荐
              <span>＞＞</span>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ moreVerbTab }}<i class="iconfont iconxiala2"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in verbs" :key="`moreVerbTab&${index}`" :command="item">{{ item.subtitle }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </h6>
            <div class="writing-word-top-item-tags">
              <span class="writing-word-top-item-tag" :class="{'active': checkActiveWordTagFunc(item.cn)}" v-for="(item, index) in moreVerbList" :key="`moreVerbTag&${index}`" @click="toggleWordTagFunc(item.cn)">{{ item.cn }}</span>
            </div>
          </div>
          
          <!-- 收起按钮 -->
          <div class="writing-word-slide-up-btn" @click="toggleSlideVisibleFunc()">
            <i class="iconfont iconshouqi"></i>
            <span>收起关键词</span>
          </div>

        </template>

      </div>

      <!-- 智能写简历 搜索结果 -->
      <div class="writing-result">
        
        <template v-if="searchResultList && searchResultList.length">
          <p v-for="(item, index) in lineHeightsearchResultList" :key="`writingResult&${index}`" @click="selectDescFunc(index)" v-html="item"></p>
          <!-- 切换其他结果 -->
          <div class="writing-result-random-btn" @click="changePageFunc()">
            <i class="iconfont iconhuanyihuan1"></i>
            <span>换一换</span>
          </div>
        </template>

        <template v-else>
          <div class="no-data-search-result">
            <img src="https://files.wondercv.com/b-pc-calendar/not-data.png" alt="no-data">
            <p>暂无匹配结果</p>
          </div>
        </template>

      </div>

    </div>
    
    <!-- content 大牛案例  -->
    <div class="example-content" v-show="currentId === 1 && auxiliaryPackup">
      <div class="example-header">
        <!--        {{ exampleOptions }}-->
        <!--        {{ exampleTags }}-->
        <el-select v-model="exampleOption" placeholder="请选择" @change="exampleOptionChange">
          <el-option
              v-for="item in exampleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="exampleTag" placeholder="请选择" @change="exampleTagChange">
          <el-option
              v-for="item in exampleTags"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <div class="more-example" style="border: none"></div>
<!--        <a class="more-example" target="_blank" href="/jianlimoban/">更多大牛案例</a>-->
      </div>
      <div class="example-item-content">
        <template v-for="(item, index) in examples">
          <div :key="index" class="example-item-info">
            <div class="example-user-info" v-if="item.user && item.user.avatar && item.user.username">
              <img :src="item.user.avatar" alt="">
              <span>{{ item.user.username }}</span>
            </div>
            <div class="example-item" v-html="item.detail"/>
          </div>
        </template>
      </div>
    </div>

    <!-- content 填写贴士 -->
    <div class="faq-content" v-show="currentId === 2 && auxiliaryPackup">
      <template v-for="(item, index) in faqs">
        <div class="faq-item" :key="index">
          <div class="faq-item-header" @click="changeFaqItemState(index)">
            <span>{{ lang === 'en' ? item.en_headerline : item.headerline }}</span>
            <i class="iconfont" :class="faqActive[index] ? 'iconshangla' : 'iconxiala'"></i>
          </div>
          <div class="faq-item-content" v-show="faqActive[index]"
               v-html="lang ==='en' ? item.en_desc : item.desc"></div>
        </div>
      </template>
    </div>

    <!-- content 常用动词 -->
    <div class="verbs-content" v-show="currentId === 3 && auxiliaryPackup">
      <div class="verbs-header">
        <el-select v-model="verbValue" placeholder="请选择">
          <el-option
              v-for="item in verbOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="verbLang" placeholder="请选择">
          <el-option
              v-for="item in [ { label: '中文', value: 'cn' }, { label: '英文', value: 'en' } ]"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="verbs-item-content">
        <template v-for="(item, index) in verbContent">
          <div class="verbs-item" :key="index">{{ item[verbLang] }}</div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import api from '../../../../../api'

	export default {
		name: 'cv-auxiliary',
		data () {
			return {
				currentId: -1,
				faqActive: [],
				verbValue: '',
				verbLang: 'cn',
				exampleOption: '',
				exampleTag: '',
				exampleTags: [],
				exampleOptions: [],
        backUpId: 1,
        exampleState: true,
        writingSearchWord: null, // 搜索词
        verbList: [],
        nounList: [],
        moreVerbTab: null, // 更多动词分类
        moreVerbList: [], // 更多动词分类列表
        moreVerbVisible: false, // 更多动词模块 visible
        slideVisible: false, // 选择动名词模块展开和收起 visible
        searchTagList: [], // 搜索框 tag 列表
        searchResultList: [], // 搜索结果列表
        isComposing:false, //搜索框值，仅做监听
        page: 1,
        size: 5,
        totalCount: 0,
        randomTipsVisible: false,
        voidTagList: ['i','<','>','<i','<i>','</','</i','/i','/i>','<i/>','style','font','weight','500','color','4183FF','#','normal',':',';']
			}
		},
		async created () {
      this.randomTipsVisible = localStorage.getItem('autoWritingRandomSearchTips')
      // 如果没有弹出过，3秒后关系
      if(!this.randomTipsVisible){
        setTimeout(() => {
          this.randomTipsVisible = true;
          localStorage.setItem('autoWritingRandomSearchTips', true)
        }, 3000)
      }
      // 获取当前工作经历下
      if (this.currentInfo.type === 'works' && this.currentInfo.data.title) {
        let params = {
          job_title: this.currentInfo.data.title
        }
        let res = await api.cvsEditor.getPostLevelId(params)
        if (res.code === 1000) {
          let id = res.data.level3_ids[0] || ''
          this.setPostId(id)
        }
      }

      this.getRecommendWords()
      this.getHighFrequencyVerbs();
		},
		computed: {
			...mapState('editor', [ 'postId', 'examples', 'example_tags', 'example_options', 'verbs', 'faqs', 'cvDetail', 'currentInfo', 'getAssistInfo', 'auxiliaryPackup' ]),

      // 高亮搜索结果列表
      lineHeightsearchResultList () {
        // 过滤掉非汉字 tag
        // let reg = new RegExp('^[\u4E00-\u9FFF]+$');
        // let tagList = this.searchTagList.filter(item => reg.test(item))
        let tagList = [...this.searchTagList]
        let list = [...this.searchResultList]

        tagList.forEach((tagItem, tagIndex) => {
          list.forEach((textItem, textIndex) => {
            if (this.voidTagList.indexOf(tagItem) !== -1) {

            } else {
              list[textIndex] = textItem.replace(new RegExp(tagItem, 'gi'), `<i style="font-weight: 500;color: #4183FF;font-style:normal;">${tagItem}</i>`)
            }
          })
        })

        return list
      },
      // 最多 8个 tag
      maxTagLength () {
        return this.searchTagList.length < 8
      },
			lang () {
				let { basic_info: { lang } } = this.cvDetail
				return lang
			},
			// 中文工作模块
			workCn () {
				let { type } = this.currentInfo
				let { basic_info: { lang } } = this.cvDetail
				return type === 'works' && lang === 'cn'
			},
			// verb option
			verbOptions () {
				return this.verbs.map(item => {
					return {
						value: item.subtitle,
						label: item.subtitle
					}
				})
			},
			// 动词内容
			verbContent () {
				let content = this.verbs.find(item => item.subtitle === this.verbValue)
				if (content) {
					return content.values
				} else {
					return []
				}
			},
      // 是否显示了大牛，贴士，动词
      blockState() {
			  return this.currentId === 0 || this.currentId === 1 || this.currentId === 2 || this.currentId === 3
      },
			// 案例的选项
			// exampleOptions () {
			// 	if (this.workCn) {
			// 		return this.example_options.map(item => {
			// 			return {
			// 				value: item.id,
			// 				label: item.name
			// 			}
			// 		})
			// 	} else {
			// 		return this.example_options.map(item => {
			// 			return {
			// 				value: item,
			// 				label: item
			// 			}
			// 		})
			// 	}
			// },
			// exampleTags () {
			// 	if (this.workCn) {
			// 		return this.example_tags.map(item => {
			// 			return {
			// 				value: item.id,
			// 				label: item.name
			// 			}
			// 		})
			// 	} else {
			// 		return this.example_tags.map(item => {
			// 			return {
			// 				value: item,
			// 				label: item
			// 			}
			// 		})
			// 	}
			// },
			// auxiliary 配置
			auxiliaryOption () {
				return [
          { id: 0, name: '简历例句', show: this.workCn },
					{ id: 1, name: '大牛案例', show: this.exampleOptions && this.exampleOptions.length && this.exampleTags && this.exampleTags.length },
					{ id: 2, name: '填写贴士', show: this.faqs && this.faqs.length },
					{ id: 3, name: '常用动词', show: this.verbOptions && this.verbOptions.length && !this.workCn }
				]
			},
		},
		watch: {
      // 'currentInfo.data.title': {
      //   handler () {
      //     console.log(this.currentInfo.data.title)
      //   },
      //   deep: true
      // },
      'currentInfo.data.title': {
        handler () {
          let timer = setTimeout(async () => {
            clearTimeout(timer)
            if (!this.postId) {
              // 默认用 产品经理 id
              await this.setPostId('3001004')
            }
            this.getRecommendWords()
          }, 200)
        },
        deep: true
      },
			faqs: {
				handler () {
					this.faqActive = Array.from({ length: this.faqs.length }, (item, index) => !index)
					setTimeout(() => {
						this._initValueSelect()
					}, 30)
				},
				deep: true
			},
			example_tags: {
				handler (val) {
          if (this.workCn) {
            this.exampleTags = this.example_tags.map(item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          } else {
            this.exampleTags = this.example_tags.map(item => {
              return {
                value: item,
                label: item
              }
            })
          }
          this._initExampleSelect()
				}
			},
			example_options: {
				handler () {
          this.exampleTag = ''
          if (this.workCn) {
            this.exampleOptions = this.example_options.map(item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          } else {
            this.exampleOptions = this.example_options.map(item => {
              return {
                value: item,
                label: item
              }
            })
          }
          this._initExampleSelect()
				}
			},
      verbOptions: {
				handler () {
					this._initVerbSelect()
        }
      },
      'currentInfo.type' (val) {
        this.exampleOption = ''
        this.exampleTag = ''
        this.exampleOptions = null
        this.exampleTags = null
      }
		},
		methods: {
			...mapActions('editor', ['getPostLevelId']),
			...mapMutations('editor', [ 'setPostId', 'setAssistInfo', 'upateAuxiliaryPackup' ]),

      // 随机搜索
      async randomSearchFunc () {
        this.randomTipsVisible = true
        localStorage.setItem('autoWritingRandomSearchTips', true)
        let verbList = [...this.verbList].splice(0, 10)
        let nounList = [...this.nounList].splice(0, 12)
        let verbIndex = Math.floor( Math.random() * verbList.length )
        let nounIndex = Math.floor( Math.random() * nounList.length )
        this.searchTagList = [verbList[verbIndex].cn, nounList[nounIndex]]
        this.page = 1
        await this.getAutoWritingList()
        // 同步到简历
        this.selectDescFunc(0)
      },
      changePageFunc () {
        // 切换下一页
        let page = (this.page + 1) % Math.ceil(this.totalCount / 5)
        if (page === 0) page = Math.ceil(this.totalCount / 5)
        this.page = page
        // 接口搜索
        this.getAutoWritingList()
      },
      searchTagDeleteFunc (wordTag) {
        this.page = 1
        this.delSearchTagFunc(wordTag)
        // 接口搜索
        this.getAutoWritingList()
      },
      // 删除 tag
      delSearchTagFunc (wordTag) {
        let index = this.searchTagList.indexOf(wordTag)
        this.searchTagList.splice(index, 1)
      },
      // 添加 tag
      addSearchTagFunc (wordTag) {
        this.searchTagList.push(wordTag)
      },
      checkInputFunc (e) {
        this.isComposing = e.isComposing
      },
      // 检查 是否是有效 word tag（不重复）
      checkValidWordTagFunc (wordTag) {
        return this.searchTagList.indexOf(wordTag) === -1
      },
      // 监听 word tag 是否活跃
      checkActiveWordTagFunc (wordTag) {
       return this.searchTagList.indexOf(wordTag) !== -1
      },
      // 添加或删除 tag
      toggleWordTagFunc (wordTag) {
        // 添加
        if (this.checkValidWordTagFunc(wordTag)) {
          // 最多 8个 tag
          if (!this.maxTagLength) return false
          this.addSearchTagFunc(wordTag)
          this.page = 1
          // 接口搜索
          this.getAutoWritingList()
        // 删除
        } else {
          this.delSearchTagFunc(wordTag)
          this.page = 1
          // 接口搜索
          this.getAutoWritingList()
        }
      },
      // 键盘 enter 搜索
      keyboardSearchFunc () {
        // 最多 8个 tag
        if (!this.maxTagLength) return this.writingSearchWord = null
        // 空值回车不添加
        if (!this.writingSearchWord) return false
        // 重复值不添加
        if (!this.checkValidWordTagFunc(this.writingSearchWord)) return this.writingSearchWord = null
        // console.log('搜索')
        // 添加 tag
        this.addSearchTagFunc(this.writingSearchWord)
        // 清空搜索框
        this.writingSearchWord = null
        this.page = 1
        // 接口搜索
        this.getAutoWritingList()
      },
      // 键盘 backspace 删除搜索 tag
      keyboardDelSearchFunc () {
        if (this.isComposing) return false
        // input 有值不删除 tag
        if (this.writingSearchWord) return false
        // console.log('删除搜索')
        // 删除搜索
        this.searchTagList.pop()
        this.page = 1
        // 接口搜索
        this.getAutoWritingList()
      },
      // 获取动词名词列表
      async getRecommendWords () {
        try {
          let params = {
            level_id: this.postId || "3001004"
          }
          let res = await api.cvsEditor.getRecommendWords(params)
          if (res.code === 1000) {
            this.verbList = res.data.verb.map((item)=>({cn:item})).splice(0,40);
            this.nounList = res.data.noun.splice(0, 40)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 获取工作经历列表
      async getAutoWritingList () {
        try {
          // if (!this.postId) {
          //   await this.getPostLevelId()
          // }
          let params = {
            page: this.page,
            size: this.size,
            profession_id: this.postId,
            text: this.searchTagList.join(' ')
          }
          let res = await api.cvsEditor.getAutoWritingList(params)
          if (res.code === 1000) {
            this.totalCount = res.data.count
            this.searchResultList = res.data.sentences || []
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 同步到简历
      selectDescFunc (index) {
        let editorContainer = document.querySelector('.tox-editor-container')
        editorContainer.classList.add('auto')
        let editorHeader = document.querySelector('.tox-editor-header')
        editorHeader.classList.add('auto')

        let text = this.searchResultList[index]
        this.$emit('on-select', { text })
      },
      // 切换 选择动名词模块 展开和收起
      toggleSlideVisibleFunc () {
        this.slideVisible = !this.slideVisible
        this.moreVerbVisible = false
      },
      // 显示更多动词模块
      showMoreVerbFunc () {
        if (!this.verbs || !this.verbs.length) return false
        this.moreVerbTab = this.verbs[0].subtitle
        this.moreVerbList = this.verbs[0].values
        this.moreVerbVisible = true
      },
      // 更多动词切换 tab
      handleCommand (command) {
        this.moreVerbTab = command.subtitle
        this.moreVerbList = command.values
      },
      changeBlockState() {      
			  if (this.blockState) {
			    this.backUpId = this.currentId
			    this.currentId = -1
        } else {
			    this.currentId = this.backUpId
        }
        this.upateAuxiliaryPackup(!this.auxiliaryPackup)
      },
			// 切换option
			changeOption (item) {
        this.upateAuxiliaryPackup(true)
				this.currentId = item.id
			},
			// 切换faq的开启关闭状态
			changeFaqItemState (index) {
				this.faqActive[index] = !this.faqActive[index]
				this.$forceUpdate()
			},
			// 案例select值发生变化
			exampleOptionChange () {
        this.exampleTag = ''
				if (this.workCn) {
					let payload = {
						profession_id: this.exampleOption
					}
					this._searchWorkExample('options', payload)
				} else {
					this._searchExample()
				}
			},
			exampleTagChange () {
				if (this.workCn) {
					let payload = {
						profession_id: this.exampleOption,
						ability_id: this.exampleTag
					}
					this._searchWorkExample('', payload)
				} else {
					this._searchExample()
				}
			},
      _initVerbSelect () {
	      this.verbValue = this.verbs && this.verbs.length && this.verbs[0].subtitle
      },
      _initExampleSelect () {
        // if (this.exampleState) {
          this.exampleOption = this.exampleOption || (this.exampleOptions && this.exampleOptions.length && this.exampleOptions[0].value)
          // this.exampleTag = ''
          this.exampleTag = this.exampleTag === '' ? (this.exampleTags && this.exampleTags.length && this.exampleTags[0].value) : this.exampleTag
          // setTimeout(() => {
          //   this.exampleState = false
          // }, 1000)
        // }
      },
			// 初始化副词的初始选中状态
			_initValueSelect () {
        // 初始化收起状态
        this.upateAuxiliaryPackup(false)
        if (this.workCn) {
          this.currentId = 0
        } else if (this.exampleOptions.length && this.exampleTags.length) {
					this.currentId = 1
				} else if (this.faqs && this.faqs.length) {
					this.currentId = 2
				} else if (this.verbs && this.verbs.length) {
					this.currentId = 3
				} else {
					this.currentId = -1
				}
			},
			// 非中文工作获取案例
			async _searchExample () {
				let { basic_info: { lang, cv_type } } = this.cvDetail
				let payload = {
					lang,
					cv_type,
					example_tag: this.exampleTag,
					example_name: this.exampleOption,
				}
				let res = await api.cvsEditor.getExamples(payload)
				if (res.code === 1000) {
          // this.exampleTag = ''
          this.setAssistInfo({ type: 'examples', info: res.data })
          // this._initExampleSelect()
				}
			},
			// 中文工作获取案例
			async _searchWorkExample (type, payload) {
				let { basic_info: { token } } = this.cvDetail
				let res = await api.cvsEditor.getWorkExamples(token, payload)
				if (res.code === 1000) {
					let info = {
						example_tags: res.data.abilities,
						examples: res.data.examples
					}
					this.setAssistInfo({ type: 'examples', info })
					if (type === 'options') this.exampleTag = res.data.abilities[0] && res.data.abilities[0].id
				}
			},
      //获取高频动词
      async getHighFrequencyVerbs(){
         try{
           let params={
             cv_type:"stu_cn",
             type:"verbs",
             submodule_type:"works"
           }
          const res= await api.cvsEditor.getAssistInfo(params);
          if(res.code===1000){
            this.verbList=res.data.verbs[0].values;
          }else{
            console.log("获取高频动词失败");
          }
         }catch(error){
           console.log(error);
         }
      }
		}
	}
</script>

<style lang="scss" scoped>
  .cv-auxiliary-container {
    margin-top: 8px;
    margin-bottom: 24px;
    .auxiliary-header {
      display: flex;
      justify-content: space-between;
      height: 56px;
      .auxiliary-option {
        display: flex;
        justify-content: flex-start;
        position: relative;
        .option-item {
          padding: 16px 0;
          margin-left: 24px;
          cursor: pointer;
          color: #606060;
          &.option-item-active {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #404040;
            font-weight: 600;
            &::after {
              content: '';
              width: 16px;
              height: 2px;
              border-radius: 1px;
              background-color: #ff6644;
              margin-top: 8px;
            }
          }
        }
        .icon-container {
          margin-right: 16px;
          padding: 16px 0;
          position: absolute;
          left: 0;
          .iconfont {
            color: #606060;
            font-size: 14px;
          }
          .block-hide {
            display: inline-block;
            transform: rotate(-90deg);
          }
        }
      }
    }
    // content 填写贴士 
    .faq-content {
      padding: 18px;
      background-color: #F9F9F9;
      border-radius: 4px;
      .faq-item {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
        .faq-item-header {
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          color: #404040;
          font-weight: 500;
          .iconfont {
            color: #D8D8D8;
          }
        }
        .faq-item-content {
          margin-top: 16px;
          line-height: 22px;
          color: #606060;
          /deep/ ul, /deep/ ol {
            padding-left: 20px;
          }
        }
      }
    }
    // content 常用动词 
    .verbs-content {
      background-color: #F9F9F9;
      border-radius: 4px;
      padding: 18px;
      .verbs-header {
        display: flex;
        align-items: center;
        .el-select {
          width: 160px;
          margin-right: 16px;
        }
      }
      .verbs-item-content {
        display: flex;
        flex-wrap: wrap;
        /*background-color: #F9F9F9;*/
        /*border-radius: 4px;*/
        margin-top: 16px;
        padding: 18px 0 4px;
        .verbs-item {
          width: 33%;
          text-align: center;
          color: #404040;
          margin-bottom: 14px;
        }
      }
    }
    // content 大牛案例 
    .example-content {
      background-color: #F9F9F9;
      border-radius: 4px;
      padding: 18px;
      .example-header {
        display: flex;
        align-items: center;
        .more-example {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 134px;
          height: 36px;
          border: 1px solid #ff6644;
          color: #ff6644;
          border-radius: 4px;
          box-sizing: border-box;
          cursor: pointer;
        }
        .el-select {
          /*width: 160px;*/
          flex: 1;
          margin-right: 16px;
        }
      }
      .example-item-content {
        /*background-color: #F9F9F9;*/
        /*border-radius: 4px;*/
        /*margin-top: 16px;*/
        padding: 18px 0;
        .example-item-info {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          .example-user-info {
            display: flex;
            align-items: center;
            margin-bottom: 6px;
            color: #404040;
            img {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .example-item {
            color: #606060;
            line-height: 24px;
            /deep/ ul, /deep/ ol {
              padding-left: 20px;
            }
          }
        }
      }
    }

    // content 智能写简历
    .writing-content {

      // 智能写简历 搜索
      .writing-search {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;

        img {
          width: 66px;
          margin-left: -13px;
        }

        .writing-search-box {
          margin-left: -13px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 80%;
          // height: 46px;
          box-sizing: border-box;
          box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
          border-radius: 23px;
          padding: 0 6px 0 20px;

          &:hover {
            box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.4);
          }

          .writing-search-input-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: calc(100% - 52px);
            padding-top: 9px;
            // height: 100%;

            .writing-search-tag {
              display: flex;
              align-items: center;
              max-width: 160px;
              box-sizing: border-box;
              padding: 4px 12px;
              background: #F9F9F9;
              border-radius: 16px;
              margin-right: 8px;
              margin-bottom: 9px;

              >span {
                display: block;
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                font-weight: 400;
                color: #404040;
                line-height: 20px;
              }

              .iconfont {
                font-size: 12px;
                color: #CFCFCF;
                margin-left: 8px;
                cursor: pointer;

                &:hover {
                  color: #606060;
                }

              }

            }

            .writing-search-input {
              // width: 120px;
              // width: 50%;
              height: 28px;
              margin-bottom: 9px;
            }

          }

          .writing-search-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            background: #F5F6FA;
            border-radius: 50%;
            cursor: pointer;

            &:hover {
              background: #EEF0F8;
            }

            .iconfont {
              color: #404040;
              font-size: 18px;
            }
          }

        }

        .writing-search-random-btn {
          position: relative;
          width: 46px;
          height: 46px;
          background: #FFFFFF;
          border-radius: 50%;
          box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
          cursor: pointer;

          &:hover {
            .search-random-tips.hover {
              display: block;
            }
            &::after {
              background: #EEF0F8;
            }
          }

          &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 36px;
            height: 36px;
            background: #F5F6FA;
            border-radius: 50%;
          }

          .iconfont {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 18px;
            color: #404040;
            z-index: 1;
          }

          .search-random-tips {
            position: absolute;
            left: -25px;
            top: -44px;
            white-space: nowrap;
            padding: 8px 16px;
            background: rgba(0, 0, 0, 0.8);
            border-radius: 2px;
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 18px;

            &.hover {
              display: none;
            }

            &::after {
              content: "";
              position: absolute;
              right: 26px;
              bottom: -6px;
              width: 0;
              height: 0;
              border-top: 6px solid rgba(0, 0, 0, 0.8);
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;

            }

          }

        }
      }

      // 智能写简历 动名词
      .writing-word {
        background: #FFFFFF;
        border-radius: 12px;
        padding: 16px 18px;
        box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
        margin-bottom: 16px;

        &.slide-down {
          padding: 12px 18px;
        }

        .writing-word-slide-down-box {
          display: flex;
          align-items: center;

          .writing-word-slide-down-title {
            flex: 1;
            height: 20px;
            position: relative;
            font-size: 14px;
            font-weight: 500;
            color: #404040;
            line-height: 20px;
            padding-left: 7px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              width: 3px;
              height: 12px;
              background: #4183FF;
              transform: translateY(-50%);
            }
          }

          .writing-word-slide-down-btn {
            display: flex;
            align-items: center;
            padding: 7px 14px;
            background: #F5F6FA;
            border-radius: 14px;
            margin-left: 16px;
            cursor: pointer;

            &:hover {
              background: #EEF0F8;
            }

            .iconfont {
              color: #404040;
              font-size: 16px;
              margin-right: 4px;
            }

            >span {
              font-size: 12px;
              font-weight: 500;
              color: #404040;
              line-height: 12px;
            }
          }

        }

        .writing-word-top {
          display: flex;

          .writing-word-top-line {
            height: 130px;
            border-left: 1px dashed #F5F6FA;
            align-self: flex-end;
          }

        }

        .writing-word-top-item {
          flex: 1;

          &.verb {
            padding-right: 12px;
            .writing-word-top-item-tags {
              height: 102px;

              &.active {
                height: 136px;
              }

            }
            .writing-word-top-item-tag {
              margin-right: 6px;
            }
          }

          &.noun {
            padding-left: 12px;
            .writing-word-top-item-header {
              // padding-left: 12px;
              padding-left: 13px;
              &::before {
                left: 6px;
              }
            }
            .writing-word-top-item-tags {
              height: 136px;
              // padding-left: 11px;
              // border-left: 1px solid #F5F6FA;
            }
            .writing-word-top-item-tag {
              margin-left: 6px;
            }
          }

          &.more-verb {
            margin-top: 24px;
            .writing-word-top-item-header {
              >span {
                margin-left: 12px;
                margin-right: 14px;
                letter-spacing: -3px;
              }
            }
            .writing-word-top-item-tag {
              margin-right: 6px;
            }

            ::v-deep {
              .el-dropdown {
                color: #4183FF;
                cursor: pointer;
                padding: 4px 10px;

                &:hover {
                  background: #F5F6FA;
                  border-radius: 6px;
                }
              }
              .iconxiala2 {
                font-size: 12px;
                margin-left: 4px;
              }
            }
          }

          .writing-word-top-item-header {
            position: relative;
            font-size: 14px;
            font-weight: 500;
            color: #404040;
            line-height: 20px;
            padding-left: 7px;
            margin-bottom: 10px;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              width: 3px;
              height: 12px;
              background: #4183FF;
              transform: translateY(-50%);
            }
          }

          .writing-word-top-item-tags {
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            .writing-word-top-item-tag {
              font-size: 14px;
              font-weight: 400;
              color: #9C9C9C;
              line-height: 20px;
              border-radius: 16px;
              border: 1px solid #ECECEC;
              padding: 3px 12px;
              margin-top: 6px;
              cursor: pointer;

              &.active {
                color: #ffffff;
                background: #4183FF;
                border-color: #4183FF;
              }

              &:hover {
                color: #FFFFFF;
                background: #679CFF;
                border-color: #679CFF;
              }

            }
          }

          .writing-word-top-item-more-btn {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: #606060;
            line-height: 20px;
            border-radius: 16px;
            border: 1px solid #ECECEC;
            padding: 3px 12px;
            margin-top: 6px;
            cursor: pointer;

            &:hover {
              color: #404040;
              border-color: #cfcfcf;
            }

            >span {
              letter-spacing: -3px;
            }

          }

        }

        // 收起按钮
        .writing-word-slide-up-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 149px;
          height: 36px;
          background: #F5F6FA;
          border-radius: 18px;
          border-radius: 18px;
          margin: 0 auto;
          margin-top: 22px;
          cursor: pointer;

          &:hover {
            background: #EEF0F8;
          }

          .iconfont {
            color: #404040;
            font-size: 16px;
            margin-right: 4px;
          }

          >span {
            font-size: 14px;
            font-weight: 500;
            color: #404040;
            line-height: 14px;
            letter-spacing: 1px;
          }
        }

      }

      // 智能写简历 搜索结果
      .writing-result {
        padding: 14px 12px 22px;
        background: #FFFFFF;
        box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
        border-radius: 12px;

        >p {
            position: relative;
            font-size: 14px;
            color: #404040;
            line-height: 22px;
            margin-bottom: 4px;
            cursor: pointer;
            padding: 10px 12px;
            padding-left: 27px;

            &:hover {
              background: #F5F6FA;
              border-radius: 10px;
            }

            &:last-of-type {
              margin-bottom: 0;
            }

            &::before {
              content: "";
              position: absolute;
              top: 18px;
              left: 11px;
              width: 5px;
              height: 5px;
              background: #404040;
              border-radius: 50%;
            }
        }

        .writing-result-random-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 36px;
          background: #F5F6FA;
          border-radius: 18px;
          box-sizing: border-box;
          cursor: pointer;
          margin: 22px auto 0;

          &:hover {
            background: #EEF0F8;
          }

          .iconfont {
            color: #404040;
            font-size: 16px;
            margin-right: 6px;
          }

          >span {
            font-size: 14px;
            font-weight: 500;
            color: #404040;
            line-height: 14px;
            letter-spacing: 1px;
          }
        }

        .no-data-search-result {
          display: flex;
          align-items: center;
          flex-direction: column;
          padding: 42px 0 34px;

          >img {
            width: 60px;
            margin-bottom: 16px;
          }

          >p {
            color: #404040;
            text-align: center;
            font-size: 14px;
          }
        }

      }

    }

  }
</style>